var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17944 16.1185C4.61025 16.1185 5.77014 17.2858 5.77014 18.7259C5.77014 20.1659 4.61025 21.3333 3.17944 21.3333C1.74864 21.3333 0.588745 20.1659 0.588745 18.7259C0.588745 17.2858 1.74864 16.1185 3.17944 16.1185Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3811 16.1185C12.8119 16.1185 13.9718 17.2858 13.9718 18.7259C13.9718 20.1659 12.8119 21.3333 11.3811 21.3333C9.9503 21.3333 8.79041 20.1659 8.79041 18.7259C8.79041 17.2858 9.9503 16.1185 11.3811 16.1185Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5829 16.1185C21.0137 16.1185 22.1736 17.2858 22.1736 18.7259C22.1736 20.1659 21.0137 21.3333 19.5829 21.3333C18.1521 21.3333 16.9922 20.1659 16.9922 18.7259C16.9922 17.2858 18.1521 16.1185 19.5829 16.1185Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17944 8.34333C4.61025 8.34333 5.77014 9.51072 5.77014 10.9508C5.77014 12.3908 4.61025 13.5582 3.17944 13.5582C1.74864 13.5582 0.588745 12.3908 0.588745 10.9508C0.588745 9.51072 1.74864 8.34333 3.17944 8.34333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3811 8.34333C12.8119 8.34333 13.9718 9.51072 13.9718 10.9508C13.9718 12.3908 12.8119 13.5582 11.3811 13.5582C9.9503 13.5582 8.79041 12.3908 8.79041 10.9508C8.79041 9.51072 9.9503 8.34333 11.3811 8.34333Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5829 8.34333C21.0137 8.34333 22.1736 9.51072 22.1736 10.9508C22.1736 12.3908 21.0137 13.5582 19.5829 13.5582C18.1521 13.5582 16.9922 12.3908 16.9922 10.9508C16.9922 9.51072 18.1521 8.34333 19.5829 8.34333Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17944 0.568429C4.61025 0.568429 5.77014 1.73582 5.77014 3.17586C5.77014 4.61591 4.61025 5.78329 3.17944 5.78329C1.74864 5.78329 0.588745 4.61591 0.588745 3.17586C0.588745 1.73582 1.74864 0.568429 3.17944 0.568429Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3811 0.568429C12.8119 0.568429 13.9718 1.73582 13.9718 3.17586C13.9718 4.61591 12.8119 5.78329 11.3811 5.78329C9.9503 5.78329 8.79041 4.61591 8.79041 3.17586C8.79041 1.73582 9.9503 0.568429 11.3811 0.568429Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5829 0.568429C21.0137 0.568429 22.1736 1.73582 22.1736 3.17586C22.1736 4.61591 21.0137 5.78329 19.5829 5.78329C18.1521 5.78329 16.9922 4.61591 16.9922 3.17586C16.9922 1.73582 18.1521 0.568429 19.5829 0.568429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDial);
export default __webpack_public_path__ + "static/media/Dial.677a7280d1bbeca6b38e4ef279af55cf.svg";
export { ForwardRef as ReactComponent };